<template>
  <section class="mensaje-inicial">
    <b-icon icon="inbox-outline" size="is-large" />
    <p class="mensaje-inicial-titulo">{{ titulo }}</p>
    <p class="mensaje-inicial-sub">{{ subtitulo }}</p>
  </section>
</template>
<script>
    export default{
        name: "mensajeInicial",
        props: ["titulo", "subtitulo"]
    }
</script>
